export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#007D6C" stroke="#95C11F" strokeWidth="2.5" />
    <circle cx="42" cy="21" r="4.5" fill="#95C11F" />
    <path d="M10 46 L26 21 L33 31 L39 25 L54 46 Z" fill="#FFFFFF" />
    <path d="M10 46 L21 38 L27 41 L35 35 L44 40 L54 46 Z" fill="#77C8D3" />
  </svg>
);

export const Logo = ({ className = "h-6 sm:h-7", tone = "color" }) => (
  <img
    src="/assets/logo.webp"
    alt="Himachal हो!"
    className={`w-auto ${tone === "white" ? "brightness-0 invert" : ""} ${className}`}
  />
);
